import React, { useContext, useEffect, useState } from 'react';
import { 
    Table, 
    TableContainer, 
    TableHead, 
    TableRow, 
    TableCell, 
    TableBody, 
    Paper, 
    Box, 
    Typography, 
    Popover, 
    TextField, 
    TablePagination, 
    Tabs, 
    Tab, 
    Link, 
    Grid, 
    Button 
} from '@mui/material';
import { homeBackground } from './common/ColorCodes';
import TopBar from './common/home/TopBar';
import Footer from './common/home/Footer';
import './common/Styles.css'
import DebugService from '../services/DebugService';
import { 
    CONST_CASE_APPOINTMENT_BOOKING, 
    CONST_CASE_CONTACT_US, 
    CONST_CONTACT_US_COMPLETE_STATUS, 
    CONST_SITE_LABEL, 
    QUERY_LOG_ACCESS_LIST, 
    STORAGE_KEYS
} from './common/Helper';
import { format } from 'date-fns';
import { useConfirm } from 'material-ui-confirm';
import { AppContext } from '../state/AppContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { 
    DateRangePicker, 
    MultiInputTimeRangeField 
} from '@mui/x-date-pickers-pro';
import { styles } from './common/Styles';
import dayjs from 'dayjs';
import AppointmentBookingApiService from '../services/AppointmentBookingApiService';
import ContactUsApiService from '../services/ContactUsApiService';
import TableLoader from './common/contentloader/TableLoader';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CONST_ROUTE_PATH } from '../route/RouteConstants';
import { useScopedLocalStorage } from '../hooks/useScopedLocalStorage';


/**
 * Mark as Complete component
 * @param {*} props 
 * @returns 
 */
export const MarkAsComplete = (props) => {
    const [completeDate, setCompleteDate] = useState(props['completeDate'])
    const [activeTab, setActiveTab] = useState(props['activeTab'])
    const [itemId, setItemId] = useState(props['itemId'])

    const {refresh, setRefresh} = useContext(AppContext)

    const confirm = useConfirm()

    /**
     * Mark as Completed handler
     */
    const markAsCompleteHandler = () => {
        confirm({
            description: 'Are you sure to mark it as complete ?'
        })
        .then(() => {
            console.log(`Marking as Completed for ${activeTab}`)

            if (activeTab === CONST_CASE_CONTACT_US) {
                // Mark as Completed in Contact Us
                ContactUsApiService.update({
                    status: CONST_CONTACT_US_COMPLETE_STATUS
                },
                itemId)
                .then(() => {
                    setRefresh(true)
                    DebugService.log(`Item with id ${itemId} is marked as Completed successfully`)
                })
                .catch(err => {
                    console.log('Caught error while marking as Completed', err)
                })
            } else {

                // Mark as Completed in Appointment Booking
                AppointmentBookingApiService.update({
                    status: CONST_CONTACT_US_COMPLETE_STATUS // Using Contact us constant since the value is same
                },
                itemId)
                .then(() => {
                    setRefresh(true)
                    DebugService.log(`Item with id ${itemId} is marked as Completed successfully`)
                })
                .catch(err => {
                    console.log('Caught error while marking as Completed', err)
                })
            }
        }).catch((err) => {
            console.log(`Request to mark as Completed is rejected for ${activeTab}`, err)
        })
    }

    return (
        <>
            {   
                completeDate 
                ? new Date(completeDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                : (
                    <Link onClick={() => markAsCompleteHandler()} style={{
                        fontSize: '10px',
                        textDecoration: 'none',
                        color: '#0096FF',
                        cursor: 'pointer',
                        '&:hover' :{
                            backgroundColor: '#ddd'
                        }
                    }}>Mark as Complete</Link>
                )
            }
        </>
    )
}

/**
 * @description Popup data display component
 * @param {*} popupData 
 * @returns 
 */
export const PopupSection = (props) => {
    const [popupData, setPopupData] = useState(props['popupData'])
    return (
        <Box className='popup-section' >
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 100 }} size="small" aria-label="a dense table">
                <TableBody>
                { popupData['name'] !== undefined && (<TableRow>
                    <TableCell component="th" scope="row" style={{
                        fontWeight: 600
                    }}>
                        Name
                    </TableCell>
                    <TableCell>{popupData['name']}</TableCell>
                    </TableRow>
                )}
                { popupData['email'] !== undefined && (<TableRow>
                    <TableCell component="th" scope="row" style={{
                        fontWeight: 600
                    }}>
                        Email
                    </TableCell>
                    <TableCell>{popupData['email']}</TableCell>
                    </TableRow>
                )}
                { popupData['phoneNumber'] !== undefined && (<TableRow>
                        <TableCell component="th" scope="row" style={{
                        fontWeight: 600
                    }}>
                            Phone Number
                        </TableCell>
                        <TableCell>{popupData['phoneNumber']}</TableCell>
                        </TableRow>
                )}
                { popupData['organization'] !== undefined && (<TableRow>
                        <TableCell component="th" scope="row" style={{
                        fontWeight: 600
                    }}>
                            Organization
                        </TableCell>
                        <TableCell>{popupData['organization']}</TableCell>
                        </TableRow>
                )}
                { popupData['message'] !== undefined && (<TableRow>
                        <TableCell component="th" scope="row" style={{
                        fontWeight: 600
                    }}>
                            Message
                        </TableCell>
                        <TableCell>{popupData['message']}</TableCell>
                        </TableRow>
                )}
                { popupData['appointmentDateTime'] !== undefined && (<TableRow>
                        <TableCell component="th" scope="row" style={{
                        fontWeight: 600
                    }}>
                            Appointment Time
                        </TableCell>
                        <TableCell>{popupData['appointmentDateTime']}</TableCell>
                        </TableRow>
                )}
                </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

/**
 * @description Logs Table
 * @param {*} props 
 * @returns 
 */
export const QueryLogsTable = (props) => {
    const [data, setData] = useState(props.data ?? [])
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [currentPage, setCurrentPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [dataCount, setDataCount] = React.useState(props.data.length ?? 0);
    const [popupData, setPopupData] = React.useState(null);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handlePopupClose = () => {
        setAnchorEl(null);
    };

    /**
     * To get current page data
     * @returns 
     */
    const getCurrentPageData = () => {
        return data.slice((currentPage * rowsPerPage) , ((currentPage * rowsPerPage) + rowsPerPage));
    };

    /**
     * Subject click handler
     * @param {*} event 
     */
    const handleClick = (event, data) => {
        setAnchorEl(event.currentTarget);
        let popupDataFormat = null

        if (data['case'] === CONST_CASE_CONTACT_US) {
            popupDataFormat = {
                name: `${data['raw']['firstname']} ${data['raw']['lastname']}`,
                email: data['raw']['email'],
                phoneNumber: data['raw']['phoneNumber'],
                organization: data['raw']['organization'],
                message: data['raw']['message']
            }
        } else {
            const formatDate = format(data['raw']['appointmentDate'], "EEEE, dd MMMM, yyyy")
            const formatTime = format(data['raw']['startTime'], "h:mm a")
            const formatEndTime = format(data['raw']['endTime'], "h:mm a")
            popupDataFormat = {
                name: data['raw']['name'],
                email: data['raw']['email'],
                phoneNumber: data['raw']['phoneNumber'],
                appointmentDateTime: `${formatTime} - ${formatEndTime}, ${formatDate}`,
            }
        }

        setPopupData(popupDataFormat)
    };

    /**
     * Page number change handler
     * @param {*} event 
     * @param {*} value 
     */
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    /**
     * Pagination row change handler
     * @param {*} event 
     */
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0)
      };

    useEffect(() => {
        document.title = `${CONST_SITE_LABEL} | Query Logs`
    },[])

    return (
        <>
            {/* Data Table */}
            <TableContainer sx={{ boxShadow: " rgba(0, 0, 0, 0.15) 0px 2px 8px;", maxHeight: 440 }} component={Paper}>
            <Table stickyHeader size='small' >
                <TableHead aria-describedby={id} >
                    <TableRow className='Table-row' >
                        <TableCell align='left' className='Table-cell'>Subject</TableCell>
                        <TableCell align='center' className='Table-cell'>Date</TableCell>
                        <TableCell align='center' className='Table-cell'>Complete Date</TableCell>
                        <TableCell align='center' className='Table-cell'>Status</TableCell>
                    </TableRow>
                </TableHead>

                {/* Popup */}
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopupClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}>
                        {popupData !== null && <PopupSection popupData={popupData}></PopupSection>}
                </Popover>

                {/* Table Body */}
                <TableBody sx={{ overflow: "auto" }}>
                    {/* Table content display */}
                    {getCurrentPageData().map((log, index) => (
                        <TableRow key={index} style={{
                            
                        }}>
                            <TableCell align='left' title='Click to view details' style={{ 
                                cursor: "pointer",
                                color: '#383838'

                            }} onClick={(e) => handleClick(e, log)}>{log.subject}</TableCell>
                            <TableCell align='center' style={{color: '#383838'}}>{new Date(log.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</TableCell>
                            <TableCell align='center' style={{color: '#383838'}}>
                                <MarkAsComplete completeDate={log.completeDate} activeTab={log.case} itemId={log['raw']['id']}></MarkAsComplete>
                            </TableCell>
                            <TableCell align='center' sx={
                                { color: log.status === 'Completed' ? '#229954' : '#D4AC0D' }
                            }>{log.status}</TableCell>
                        </TableRow>
                    ))}

                    {/* No data available message */}
                    {getCurrentPageData().length === 0 && (
                        <TableRow>
                            <TableCell colSpan={5} align='center' style={{color: '#383838'}} >
                                <Typography variant='body1' style={{ marginTop: "2vw" }}>
                                    No data available
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>

            </Table>
            </TableContainer>

            {/* <Box className='pagination-section' > */}
            {/* <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                size="large"
                className="pagination"
            /> */}

            {/* Pagination */}
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={dataCount}
                rowsPerPage={rowsPerPage}
                page={currentPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />

            {/* </Box> */}
        </>
    )
}

/**
 * @description Appointment Booking Time Availability Scheduler Component
 * @returns 
 */
export const TimeAvailabilityScheduler = () => {
    const [dateFrom, setDateFrom] = useState(format((new Date()).toDateString(), 'yyyy-MM-dd'))
    const [dateTo, setDateTo] = useState((new Date()).toLocaleDateString())
    const [timeFrom, setTimeFrom] = useState('')
    const [timeTo, setTimeTo] = useState('')
    const [disableSaveBtn, setDisableSaveBtn] = useState(true)
    const [timeAvailabilityData, setTimeAvailabilityData] = useState([])
    const [isLoading, setIsLoading] = React.useState(false);

    /**
     * Handle Date availability selection
     * @param {*} value 
     */
    const handleMeetingDateRangeSelect = (value) => {
        const dtFrom = new Date(value[0])
        const dtTo = new Date(value[1])
        DebugService.log('Selected date availability', dtFrom, dtTo)
        setDateFrom(dtFrom.toDateString())
        setDateTo(dtTo.toDateString())
    }
    
    /**
     * Handle Time availability selection
     * @param {*} value 
     */
    const handleMeetingTimeRangeSelect = (value) => {
        const tFrom = new Date(value[0])
        const tTo = new Date(value[1])
        DebugService.log('Selected time availability', value, tFrom, tTo)

        if (value[0] !== null && tFrom != 'Invalid Date') {
            setTimeFrom(tFrom)
        }
        if (value[1] !== null && tTo != 'Invalid Date') {
            setTimeTo(tTo)
        }
    }

    /**
     * Save time availability handler
     * @param {*} event 
     */
    const saveClickHandler = (event) => {
        let d = new Date(dateFrom)
        let nthDay = 0

        // Initialize end time using "Date From" field and "Time From" field
        const startTimeCustom = new Date(dateFrom)
        startTimeCustom.setHours(timeFrom.getHours())
        startTimeCustom.setMinutes(timeFrom.getMinutes())
        startTimeCustom.setSeconds(0)
        startTimeCustom.setMilliseconds(0)

        // Initialize end time using "Date From" field and "Time To" field
        const endTimeCustom = new Date(dateFrom)
        endTimeCustom.setHours(timeTo.getHours())
        endTimeCustom.setMinutes(timeTo.getMinutes())
        endTimeCustom.setSeconds(0)
        endTimeCustom.setMilliseconds(0)

        DebugService.log('Query Log Component: Initiated time availability save', dateFrom, dateTo, startTimeCustom, endTimeCustom)

        // Iterate "Date From" to "Date To" values to find their time slots
        do {
            DebugService.log('----------------------------------------')
            const startTime = nthDay > 0 
                ? (new Date(startTimeCustom.setDate(startTimeCustom.getDate() + 1))).getTime()
                : (new Date(startTimeCustom)).getTime()
            const endTime = nthDay > 0 
                ? (new Date(endTimeCustom.setDate(endTimeCustom.getDate() + 1))).getTime()
                : (new Date(endTimeCustom)).getTime()

            const requestBody = {
                "appointmentDate": format(d, 'yyyy-MM-dd'),
                "slots": [
                    {
                        "startTime": startTime,
                        "endTime": endTime
                    }
                ]
            }

            DebugService.log(
                'Query Log Component: Saving time availability request',
                requestBody,
                new Date(startTime),
                new Date(endTime)
            )

            AppointmentBookingApiService.saveTimeAvailability(requestBody)
            .then(response => {
                DebugService.log('Time availability saved successfully', response)
                resetForm()
            })
            .catch(e => {
                DebugService.error('Query Log Component: Error caught while saving time availability', e, requestBody)
            })

            d = new Date(d.setDate(d.getDate() + 1))
            nthDay += 1
        } while (d <= new Date(dateTo))
    }

    /**
     * Reset form handler
     */
    const resetForm = () => {
        setDateFrom((new Date()).toDateString())
        setDateTo((new Date(new Date().setDate(new Date().getDate() + 7))).toDateString())
        setTimeFrom('')
        setTimeTo('')

        setDisableSaveBtn(true)
    }

    /**
     * Handle Save flow when there is a change 
     * in Date and Time availability
     */
    useEffect(() => {
        if (dateFrom == '' ||
            dateTo == '' ||
            timeFrom == '' ||
            timeTo == ''
        ) {
            setDisableSaveBtn(true)
        } else {
            setDisableSaveBtn(false)
        }

    }, [dateFrom, dateTo, timeFrom, timeTo])

    /**
     * Fetch data on save button disable state change 
     */
    useEffect(() => {
        DebugService.log('Query Log Component: Fetching time availability data ..')
        setIsLoading(true)

        AppointmentBookingApiService.getAvailableTimePeriod()
        .then(response => {
            if (response['data']) {
                const data = response['data'].sort((a, b) => {
                    if (a['startTime'] > b['startTime']) {
                        return -1; // a should come before b
                      } else if (a['startTime'] > b['startTime']) {
                        return 1; // a should come after b
                      } else {
                        return 0; // a and b are considered equal
                      }
                })
                DebugService.log('Query Log Component: Time availability data ..', data)
                setTimeAvailabilityData(data)
            } else {
                DebugService.log('Query Log Component: Time availability data not found..', response)
            }
        })
        .catch(e => {
            DebugService.error('Query Log Component: Error caught while fetching time availability data', e)
        })
        .finally(() => setIsLoading(false))
    }, [disableSaveBtn])

    return (
        <>
            <Paper className='time-availability-container'>
                <Grid item xs={12} md={6} lg={6} style={{
                    width: '50%'
                }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateRangePicker 
                            localeText={{ start: 'Date From', end: 'Date To' }} 
                            // value={[dateFrom, dateTo]}
                            disablePast={true}
                            onChange={(value) => handleMeetingDateRangeSelect(value)}
                            // onError={(e) => {
                            //     setDateFrom('')
                            //     setDateTo('')
                            // }}
                        />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MultiInputTimeRangeField
                            style={{
                                marginTop: '1vw'
                            }}
                            slotProps={{
                                textField: ({ position }) => ({
                                label: position === 'start' ? 'Time From' : 'Time To',
                                }),
                            }}
                            value={[dayjs(timeFrom), dayjs(timeTo)]}
                            disableIgnoringDatePartForTimeValidation={true}
                            // minTime={new Date(2000, 1, 1, 12, 0)}
                            // maxTime={new Date(2000, 1, 1, 17, 0)}
                            onChange={(value) => handleMeetingTimeRangeSelect(value)}
                            // onError={(e) => {
                            //     setTimeFrom('')
                            //     setTimeTo('')
                            // }}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6} lg={6} style={{
                    width: '50%'
                }}>
                    <Box style={{
                        marginLeft: '4vw',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        {/* Date Availability Display */}
                        <Grid container spacing={2} mb={1}>
                            <Grid item xs={6} style={{ textAlign: "left" }}>
                                <Typography
                                variant="h1"
                                style={{
                                    fontWeight: "550",
                                    fontSize: "15px",
                                }}
                                >
                                Date Availability:
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: "left" }}>
                                {dateFrom} - {dateTo}
                            </Grid>
                        </Grid>

                        {/* Time Availability Display */}
                        <Grid container spacing={2} mb={1}>
                            <Grid item xs={6} style={{ textAlign: "left" }}>
                                <Typography
                                variant="h1"
                                style={{
                                    fontWeight: "550",
                                    fontSize: "15px",
                                }}
                                >
                                Time Availability:
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: "left" }}>
                                {timeFrom === '' ? timeFrom : (new Date(timeFrom)).toLocaleTimeString()} - {timeTo === '' ? timeTo : (new Date(timeTo)).toLocaleTimeString()}
                            </Grid>
                        </Grid>
                    
                        {/* Save button */}
                        <Button className='save-button' 
                            size='small' 
                            sx={styles.button1} 
                            style={{ 
                                marginTop: "30px",
                                alignItems: 'right',
                                width: '10px',
                            }} 
                            type="submit" 
                            variant="outlined" 
                            disabled={disableSaveBtn}
                            onClick={(e) => saveClickHandler(e)}
                        >
                            Save
                        </Button>
                    </Box>
                    
                </Grid>
            </Paper>

            {/* Data Table */}
            <TableContainer sx={{ boxShadow: " rgba(0, 0, 0, 0.15) 0px 2px 8px;", maxHeight: 440, mt: '5px' }} component={Paper}>
                {isLoading ? (
                    <TableLoader />
                ):(
                    <Table stickyHeader size='small' >
                        <TableHead >
                            <TableRow className='Table-row' >
                                <TableCell align='left' className='Table-cell'>Date</TableCell>
                                <TableCell align='center' className='Table-cell'>Available From</TableCell>
                                <TableCell align='center' className='Table-cell'>Available Till</TableCell>
                            </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody sx={{ overflow: "auto" }}>
                            {/* Table content display */}
                            {timeAvailabilityData.map((item, index) => (
                                <TableRow key={index} style={{
                                    backgroundColor: (new Date(item['startTime'])).setHours(0,0,0,0) === (new Date()).setHours(0,0,0,0) ? '#fffbef' : ''
                                }}>
                                    <TableCell align='left' style={{
                                        color: item['startTime'] >= (new Date()).getTime() ? '#383838' : '#999999'
                                    }}>{format(item['startTime'], 'dd LLL, yyyy')}</TableCell>
                                    <TableCell align='center' style={{
                                        color: item['startTime'] >= (new Date()).getTime() ? '#383838' : '#999999'
                                    }}>{format(item['startTime'], 'hh:mm b')}</TableCell>
                                    <TableCell align='center' style={{
                                        color: item['startTime'] >= (new Date()).getTime() ? '#383838' : '#999999'
                                    }}>{format(item['endTime'], 'hh:mm b')}</TableCell>
                                </TableRow>
                            ))}

                            {/* No data available message */}
                            {/* {getCurrentPageData().length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align='center' style={{color: '#383838'}} >
                                        <Typography variant='body1' style={{ marginTop: "2vw" }}>
                                            No data available
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )} */}
                        </TableBody>
                    </Table>
                )}
            </TableContainer>
        </>
    )
}

/**
 * Query Logs Page Component
 * @returns 
 */
const QueryLogs = () => {
    const [contactUsData, setContactUsData] = useState([])
    const [filteredContactUsData, setFilteredContactUsData] = useState([])

    const [appointmentBookingData, setAppointmentBookingData] = useState([])
    const [filteredAppointmentBookingData, setFilteredAppointmentBookingData] = useState([])
    
    const [tabValue, setTabValue] = React.useState(0);
    const [searchedValue, setSearchedValue] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);

    const {refresh, setRefresh} = useContext(AppContext)

    const location = useLocation()
    const navigate = useNavigate()
    const urlParams = useParams()
    const { getScopedItem } = useScopedLocalStorage()

    /**
   * Page load handler
   */
    useEffect(() => {
        // Fetch contact us data
        setIsLoading(true)
        ContactUsApiService.getList().then(data => {
            if (data !== undefined) {
                if (data['data'] !== undefined) {
                    DebugService.log('Contact Us list', data['data'])
                    setContactUsData(data['data'])
                    setFilteredContactUsData(mappedContactUsResult(data['data']))
                } else {
                    console.error('Contact Us list API data property is empty', data) 
                }
            } else {
                console.error('Contact Us list API response is empty', data)
            }
        }).catch(err => {
            console.error('Error while fetching Contact Us list', err)
        })
        .finally(() => setIsLoading(false))

        // Fetch appointment booking data
        setIsLoading(true)
        AppointmentBookingApiService.getList().then(data => {
        if (data !== undefined) {
            if (data['data'] !== undefined) {
                DebugService.log('Appointment Booking list', data['data'])
                setAppointmentBookingData(data['data'])
                setFilteredAppointmentBookingData(mappedAppointmentBookingResult(data['data']))
            } else {
                console.error('Appointment Booking list API data property is empty', data) 
            }
        } else {
            console.error('Appointment Booking list API response is empty', data)
        }
        }).catch(err => {
            console.error('Error while fetching Appointment Booking list', err)
        })
        .finally(() => setIsLoading(false))
    }, [refresh]);

    useEffect(() => {
        DebugService.log(`Query Logs: path changed`)

        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (!parseToJson || !QUERY_LOG_ACCESS_LIST.includes(parseToJson?.['email'])) {
            navigate(CONST_ROUTE_PATH.PAGE_NOT_FOUND)
        }
    }, [location.pathname])

    /**
     * Search handler
     * @param {*} event Input event 
     */
    const onSearchChangeHandle = (event) => {
        const inputVal = event.target.value
        setSearchedValue(inputVal)
        DebugService.log('searched logs', inputVal, inputVal.length)


        if (inputVal.length > 0) {

            // Search Contact Us data if Contact Us tabe is active
            if (tabValue === 0) {
                const searchedData = contactUsData.filter(l => l['organization'].toLocaleLowerCase().includes(inputVal.toLocaleLowerCase()) || l.status.toLocaleLowerCase().includes(inputVal.toLocaleLowerCase()))
                setFilteredContactUsData(mappedContactUsResult(searchedData))
            } else {
                const searchedData = appointmentBookingData.filter(l => l.subject.toLocaleLowerCase().includes(inputVal.toLocaleLowerCase()) || l.status.toLocaleLowerCase().includes(inputVal.toLocaleLowerCase()))
                setFilteredAppointmentBookingData(mappedAppointmentBookingResult(searchedData))
            }
            // setDataCount(searchedData.length)
        } else {
            setFilteredContactUsData(mappedContactUsResult(contactUsData))
            setFilteredAppointmentBookingData(mappedAppointmentBookingResult(appointmentBookingData))
        }
    }

    const onCancelSearchHandle = (event) => {
        console.log('onCancelSearchHandle', event)
    }

    /**
     * Tab change handler
     * @param {*} event Change event
     * @param {*} newValue Selected tab index
     */
    const handleTabChange = (event, newValue) => {
        DebugService.log('tab value change', newValue)
        setTabValue(newValue);
    };


    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;
      
        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
          >
            {value === index && (
              <Box>
                <Typography>{children}</Typography>
              </Box>
            )}
          </div>
        );
    }

    /**
     * Map contact us data into required table data
     * @param {*} data Contact Us data
     * @returns Mapped result
     */
    const mappedContactUsResult = (data) => {
        return data.map(c => {
            return {
                subject: c['organization'],
                date: c['createdOn'],
                completeDate: c['status'] === CONST_CONTACT_US_COMPLETE_STATUS ? c['updatedOn'] : undefined,
                status: c['status'],
                raw: c,
                case: CONST_CASE_CONTACT_US
            }
        })
        .sort((a, b) => a.date > b.date ? -1 : 1)
    }

    /**
     * Map appointment booking data into required table data
     * @param {*} data Appointment Booking data
     * @returns Mapped result
     */
    const mappedAppointmentBookingResult = (data) => {
        return data.map(d => {
            return {
                subject: d['subject'],
                date: d['createdOn'],
                completeDate: d['status'] === CONST_CONTACT_US_COMPLETE_STATUS ? d['updatedOn'] : undefined,
                status: d['status'],
                raw: d,
                case: CONST_CASE_APPOINTMENT_BOOKING
            }
        })
        .sort((a, b) => a.date > b.date ? -1 : 1)
    }

    return (
        <div style={{ backgroundColor: homeBackground, width: "100%" }}>
            <TopBar />
            <Box sx={{ padding: "1vw" }}>

                <Box sx={{ backgroundColor: "white", padding: "1.5vw" }}>
                    {/* Page Title */}
                    <Typography variant='h4' fontWeight={550}>
                        Query Logs
                    </Typography>

                    {/* Search Field */}
                    <TextField
                        sx={{ margin: "20px 0px" }}
                        label="Search"
                        placeholder='Search by subject or status'
                        variant="outlined"
                        onChange={(event) => onSearchChangeHandle(event)}
                    />

                    {/* Tab Selection */}
                    <Box className="tab-selection-box">
                        <Tabs value={tabValue} onChange={handleTabChange} aria-label="Query log tabs">
                            <Tab label="Contact Us" className={tabValue === 0 ? 'active-query-tab' : ''} style={{textTransform: 'capitalize'}} />
                            <Tab label="Schedule Meeting" className={tabValue === 1 ? 'active-query-tab' : ''} style={{textTransform: 'capitalize'}} />
                            <Tab label="Meeting Time Availability" className={tabValue === 2 ? 'active-query-tab' : ''} style={{textTransform: 'capitalize'}} />
                        </Tabs>
                    </Box>

                    {/* Contact Us Panel */}
                    <CustomTabPanel value={tabValue} index={0}>
                        {isLoading ? (
                            <TableLoader  />
                        ) : (
                            <QueryLogsTable data={filteredContactUsData} />
                        )}
                    </CustomTabPanel>

                    {/* Appointment Booking Panel */}
                    <CustomTabPanel value={tabValue} index={1}>
                        {isLoading ? (
                            <TableLoader />
                        ) : (
                            <QueryLogsTable data={filteredAppointmentBookingData} />
                        )}
                    </CustomTabPanel>

                    {/* Manage Appointment Booking Time Availability Panel */}
                    <CustomTabPanel value={tabValue} index={2}>
                        <TimeAvailabilityScheduler />
                    </CustomTabPanel>
                </Box>
            </Box>
            <Footer />

        </div>
    );
};

export default QueryLogs;
